import { useCallback } from 'react';

import {
  ChatCompletionResponseMessageRoleEnum,
  ChatConversation,
} from '../../types/chat-completion.type';

interface UseStreamHandlerReturn {
  handleStreamUpdate: (value: Uint8Array, decoder: TextDecoder) => void;
  createStreamReader: (
    appCompletionResponse: unknown,
  ) => Promise<ReadableStream<Uint8Array>>;
}

export function useStreamHandler(
  setConversation: React.Dispatch<React.SetStateAction<ChatConversation>>,
): UseStreamHandlerReturn {
  const handleStreamUpdate = useCallback(
    (value: Uint8Array, decoder: TextDecoder) => {
      const text = decoder.decode(value);
      setConversation((prev) => {
        if (!prev?.messages?.length) {
          return {
            messages: [
              {
                role: ChatCompletionResponseMessageRoleEnum.Assistant,
                content: text,
              },
            ],
          };
        }

        const messages = [...prev.messages];
        const lastMessage = messages[messages.length - 1];
        messages[messages.length - 1] = {
          ...lastMessage,
          content: lastMessage?.content + text,
        };

        return { ...prev, messages };
      });
    },
    [setConversation],
  );

  const createStreamReader = async (
    appCompletionResponse: unknown,
  ): Promise<ReadableStream<Uint8Array>> => {
    const reader = (
      appCompletionResponse as ReadableStream<Uint8Array>
    ).getReader();
    return reader as unknown as ReadableStream<Uint8Array>;
  };

  return { handleStreamUpdate, createStreamReader };
}
